import { FormikValues } from "formik";
import {
  Field,
  QualifiedInvestorType,
  StepEndpoint,
  StepFourPF,
  StepFivePJ,
} from "../../types";
import { radioOrSingleSelectRequired } from "../../validations";

export const qualifiedInvestorOptions = [
  {
    value: "NET_WORTH" as QualifiedInvestorType,
    label: `Sí`,
  },
  { value: "NONE" as QualifiedInvestorType, label: "No" },
];

export const getQualifiedInvestorType = (
  values: FormikValues,
): QualifiedInvestorType => {
  return (values.qualifiedInvestorType as QualifiedInvestorType) || "NONE";
};

export const parseQualifiedInvestorFromDraft = (
  qualifiedInvestorType?: QualifiedInvestorType,
) => ({
  qualifiedInvestorType: qualifiedInvestorType || "NONE",
});

// Ensures an investment-profile step (physical or juridical) never carries a
// null qualifiedInvestorType before being sent to the API.
export const normalizeInvestmentProfileForApi = <
  T extends { qualifiedInvestorType?: QualifiedInvestorType },
>(
  step: T,
): T => ({
  ...step,
  qualifiedInvestorType: step.qualifiedInvestorType ?? "NONE",
});

export const normalizePhysicalStepsForApi = (
  steps: StepEndpoint[],
): StepEndpoint[] =>
  steps.map((step) =>
    step["@type"] === "4_PHYSICAL"
      ? normalizeInvestmentProfileForApi(step as StepFourPF)
      : step,
  );

// Ensures qualifiedInvestorType is never null on the investment-profile step,
// regardless of onboarding type, before any step array is sent to the API.
export const normalizeStepsForApi = (
  steps: StepEndpoint[],
): StepEndpoint[] =>
  steps.map((step) => {
    if (step["@type"] === "4_PHYSICAL")
      return normalizeInvestmentProfileForApi(step as StepFourPF);
    if (step["@type"] === "5_JURIDICAL")
      return normalizeInvestmentProfileForApi(step as unknown as StepFivePJ);
    return step;
  });

export const getQualifiedInvestorField = (): Field[] => {
  return [
    {
      name: "qualifiedInvestorType",
      type: "radio",
      label: "¿Sos inversor calificado?",
      tooltip: {
        label: "¿Qué significa?",
        modal: "modal-qualified-investor",
      },
      validation: radioOrSingleSelectRequired(qualifiedInvestorOptions),
      options: qualifiedInvestorOptions,
      initialValue: "NONE",
      formatInPreConfirmation: (value) =>
        qualifiedInvestorOptions.find((option) => option.value === value)
          ?.label ?? value,
    },
  ];
};
